var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-fragment',{attrs:{"disabled":_vm.disabled,"size":_vm.size}},[_c('label',[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":function($event){return _vm.handleUpload($event)}}}),_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('div',[_vm._t("result")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }